<template>
    <div class="ele-body">
        <el-card shadow="never" body-style="padding-top: 5px;">
            <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="90px"
                style="max-width:800px;padding-top: 40px;" @keyup.enter.native="save"
                @submit.native.prevent>
                <el-form-item label="隐私协议:" prop="conceal_info">
                    <tinymce-editor v-model="editForm.conceal_info" :init="initEditor" />
                </el-form-item>
                <el-form-item label="登录协议:" prop="login_info">
                    <tinymce-editor v-model="editForm.login_info" :init="initEditor" />
                </el-form-item>
                <el-form-item label="用户协议:" prop="user_info">
                    <tinymce-editor v-model="editForm.user_info" :init="initEditor" />
                </el-form-item>
                <el-form-item label="骑手协议:" prop="horseman_info">
                    <tinymce-editor v-model="editForm.horseman_info" :init="initEditor" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save">保存更改</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import TinymceEditor from '@/components/TinymceEditor'
    export default {
        name: "SysSystemTreaty",
        components: {
            TinymceEditor,
        },
        data() {
            return {
                active: 'info',  // tab页选中
                table: {
                    url: '/system/SystemTreaty/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {}, // 表单数据
                editFormTemp: {},
                admin_list: [],
                user_list: [],
                search_show: false,
                editRules: { // 表单验证规则

                    conceal_info: [{
                        required: true,
                        message: '请输入隐私协议',
                        trigger: 'blur'
                    }],


                    login_info: [{
                        required: true,
                        message: '请输入登录协议',
                        trigger: 'blur'
                    }],


                    user_info: [{
                        required: true,
                        message: '请输入用户协议',
                        trigger: 'blur'
                    }],


                    horseman_info: [{
                        required: true,
                        message: '请输入骑手协议',
                        trigger: 'blur'
                    }],


                    create_time: [{
                        required: true,
                        message: '请选择',
                        trigger: 'blur'
                    }],


                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            }
        },
        mounted() {
            this.edit();
        },
        methods: {
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit() {
                this.$http.get('/system/SystemTreaty/info?id=1').then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/system/SystemTreaty/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的协议管理吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/system/SystemTreaty/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/system/SystemTreaty/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 导出数据Excel */
            exportExcel() {
                let ids = this.choose.map(d => d.id)
                if (ids.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/system/SystemTreaty/exportExcel", {
                        id: ids
                    })
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },

        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
